// extracted by mini-css-extract-plugin
export default {"container":"kunden_container__g0ffO","container__customer-name":"kunden_container__customer-name__qozoC","top-bar":"kunden_top-bar__a4mwQ"};